(function () {
  'use strict';

  var cartItemsEl = document.getElementById('QuoteCartItems');
  var emptyStateEl = document.getElementById('QuoteEmptyState');
  var formWrapEl = document.getElementById('QuoteFormWrap');
  var formEl = document.getElementById('QuoteForm');
  var successEl = document.getElementById('QuoteSuccess');
  var errorEl = document.getElementById('QuoteError');
  var submitBtn = document.getElementById('QuoteSubmitBtn');

  var config = window.__quoteConfig || {};
  var cartData = null;

  // 1. Load cart
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      cartData = cart;
      if (!cart.items || cart.items.length === 0) {
        cartItemsEl.style.display = 'none';
        emptyStateEl.style.display = '';
        return;
      }
      renderCartTable(cart);
      formWrapEl.style.display = '';
    })
    .catch(function () {
      cartItemsEl.innerHTML = '<p>Could not load cart.</p>';
    });

  // 2. Render read-only cart table on the page
  function renderCartTable(cart) {
    var html = '<table class="quote-request__table">';
    html += '<thead><tr><th></th><th>Product</th><th>SKU</th><th>Qty</th></tr></thead>';
    html += '<tbody>';
    cart.items.forEach(function (item) {
      var imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/(\.\w+)(\?|$)/, '_small$1$2')
        : '';
      html += '<tr>';
      html += '<td data-label="">';
      if (imgSrc) html += '<img src="' + imgSrc + '" alt="" width="50" height="50" style="object-fit:contain;">';
      html += '</td>';
      html += '<td data-label="Product">' + escapeHtml(item.product_title) + '</td>';
      html += '<td data-label="SKU">' + escapeHtml(item.sku || '—') + '</td>';
      html += '<td data-label="Qty">' + item.quantity + '</td>';
      html += '</tr>';
    });
    html += '</tbody></table>';
    cartItemsEl.innerHTML = html;
  }

  // 3. Form submit
  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.style.display = 'none';

      if (!formEl.checkValidity()) {
        formEl.reportValidity();
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      var businessName = formEl.business_name.value.trim();
      var email = formEl.email.value.trim();
      var yourName = formEl.your_name.value.trim();
      var message = formEl.message.value.trim();

      // Build plain text for Shopify contact form
      var itemsText = '';
      if (cartData && cartData.items) {
        cartData.items.forEach(function (item) {
          itemsText += '• ' + item.product_title;
          if (item.variant_title) itemsText += ' (' + item.variant_title + ')';
          if (item.sku) itemsText += ' [SKU: ' + item.sku + ']';
          itemsText += ' × ' + item.quantity + '\n';
        });
      }

      var bodyText = 'Business: ' + businessName + '\n'
        + 'Name: ' + yourName + '\n'
        + 'Email: ' + email + '\n\n'
        + 'Message:\n' + (message || '(none)') + '\n\n'
        + 'Items:\n' + itemsText;

      // Build structured items array for Google Apps Script
      var itemsArray = [];
      if (cartData && cartData.items) {
        cartData.items.forEach(function (item) {
          var imgUrl = '';
          if (item.featured_image && item.featured_image.url) {
            imgUrl = item.featured_image.url.replace(/(\.\w+)(\?|$)/, '_small$1$2');
          } else if (item.image) {
            imgUrl = item.image.replace(/(\.\w+)(\?|$)/, '_small$1$2');
          }
          itemsArray.push({
            title: item.product_title,
            variant: item.variant_title || '',
            sku: item.sku || '',
            quantity: item.quantity,
            image: imgUrl
          });
        });
      }

      // Dual submit: Google Apps Script (branded HTML email + sheet) + Shopify contact form (backup)
      var scriptPromise = submitToGoogleScript(businessName, email, yourName, message, itemsArray);
      var shopifyPromise = submitToShopify(businessName, email, yourName, bodyText);

      Promise.all([scriptPromise, shopifyPromise])
        .then(function () {
          return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
        })
        .then(function () {
          cartItemsEl.style.display = 'none';
          formWrapEl.style.display = 'none';
          successEl.style.display = '';
        })
        .catch(function () {
          errorEl.style.display = '';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Quote Request';
        });
    });
  }

  // 4. Google Apps Script — sends branded HTML email + logs to Google Sheet
  function submitToGoogleScript(businessName, email, yourName, message, items) {
    if (!config.googleSheetsUrl) return Promise.resolve();

    var payload = {
      timestamp: new Date().toISOString(),
      business_name: businessName,
      email: email,
      your_name: yourName,
      message: message,
      items: items
    };

    return fetch(config.googleSheetsUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(payload)
    });
  }

  // 5. Shopify contact form (plain-text backup notification)
  function submitToShopify(businessName, email, yourName, bodyText) {
    var formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[email]', email);
    formData.append('contact[name]', yourName);
    formData.append('contact[business_name]', businessName);
    formData.append('contact[subject]', 'Quote for ' + businessName);
    formData.append('contact[body]', bodyText);

    return fetch('/contact#contact_form', {
      method: 'POST',
      body: formData
    });
  }

  // Utility
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
})();
